import React from 'react';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { showConfirmationCallMessModal } from '../../../../actions/modal';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

const formateConfirmationMessageInfo = (callParticipants, actionType) => {
  let callers = callParticipants.filter(
    (participant) => participant.canAnswerCall === false && participant.participantStatus === 'T'
  );
  let providers = callParticipants.filter(
    (participant) => participant.canAnswerCall === true && participant.participantStatus === 'A'
  );

  callers = callers.map((participant) => participant.name.trim());
  providers = providers.map((participant) => participant.name.trim());

  callers = callers.length > 0 ? callers.toString().split(',').join(', ') : callers.toString();

  let confirmationMessageText = {};
  let confirmationMessageClassName = 'content confirmation-call-message ';
  if (actionType === 'add') {
    let InfoText = window.APP.LANGUAGE.ConfirmationCallModal.Add.InfoText;
    confirmationMessageText.title = window.APP.LANGUAGE.ConfirmationCallModal.Add.Title;
    confirmationMessageText.infoText = InfoText.replace('##person##', callers).replace('##person##', callers);

    confirmationMessageText.questionText = window.APP.LANGUAGE.ConfirmationCallModal.Add.QuestionText.replace(
      '##person##',
      callers
    );
    confirmationMessageText.closeCTA = window.APP.LANGUAGE.ConfirmationCallModal.Add.CloseCTA;
    confirmationMessageText.acceptCTA = window.APP.LANGUAGE.ConfirmationCallModal.Add.AcceptCTA;
    confirmationMessageClassName += 'confirmation-call-message--add-call';
  } else {
    confirmationMessageText.title = window.APP.LANGUAGE.ConfirmationCallModal.Join.Title;
    confirmationMessageText.infoText = window.APP.LANGUAGE.ConfirmationCallModal.Join.InfoText.replace(
      '##person##',
      callers
    ).replace('##provider##', providers);
    confirmationMessageText.questionText = window.APP.LANGUAGE.ConfirmationCallModal.Join.QuestionText;
    confirmationMessageText.closeCTA = window.APP.LANGUAGE.ConfirmationCallModal.Join.CloseCTA;
    confirmationMessageText.acceptCTA = window.APP.LANGUAGE.ConfirmationCallModal.Join.AcceptCTA;
    confirmationMessageClassName += 'confirmation-call-message--join-call';
  }
  return {
    confirmationMessageText,
    confirmationMessageClassName,
  };
};

const closeModal = (dispatch) => {
  dispatch(showConfirmationCallMessModal(false));
};

const renderBody = (confirmationMessageText) => {
  return (
    <>
      <p className="title-sms">{htmlToReactParser.parse(xss(confirmationMessageText.infoText))}</p>
      <p className="title-sms mrbm">{confirmationMessageText.questionText}</p>
    </>
  );
};

const renderFooter = (callerSuccessAction, closeModal, confirmationMessageText) => {
  return (
    <div className="ui actions confirmation-call-message_actions mrbm">
      <button
        type="button"
        onClick={callerSuccessAction}
        className="ui icon labeled button color-button color-button-hover color-white wdtl mrlnull mrbnull mrrxl"
      >
        <i className="checkmark  icon" />
        {confirmationMessageText.acceptCTA}
      </button>
      <button
        type="button"
        onClick={closeModal}
        className="ui cancel icon labeled button color-bad-things color-bad-things-hover color-white wdtl mrlnull"
      >
        <i className="remove  icon" />
        {confirmationMessageText.closeCTA}
      </button>
    </div>
  );
};

const ConfirmationCallMessage = (props) => {
  let { showConfirmationCallMessage, callParticipants, callerSuccessAction, actionType, dispatch } = props;

  let { confirmationMessageText, confirmationMessageClassName } = formateConfirmationMessageInfo(
    callParticipants,
    actionType
  );

  return (
    <Modal show={showConfirmationCallMessage} hideWhenClickAway={true}>
      <PopupHeader title={confirmationMessageText.title} hideHelp={true} />
      <div className={confirmationMessageClassName}>
        <div className="main-ui-container" data-rendered-as-container="true">
          <div className="content">
            <div>
              <i className="helpIconVerticalCentral ui icon warning circle" />
            </div>
            <Container fluid as={Media} greaterThanOrEqual="computer">
              <div className="pdtm pdbm pdrm pdlm">
                {renderBody(confirmationMessageText)}
                <div className="ui actions confirmation-call-message_actions mrbm">
                  {renderFooter(
                    callerSuccessAction,
                    () => {
                      closeModal(dispatch);
                    },
                    confirmationMessageText
                  )}
                </div>
              </div>
            </Container>
            <Container fluid as={Media} at="tablet">
              <div className="pdtx pdbs pdrs pdls">
                {renderBody(confirmationMessageText)}
                {renderFooter(
                  callerSuccessAction,
                  () => {
                    closeModal(dispatch);
                  },
                  confirmationMessageText
                )}
              </div>
            </Container>
            <Container fluid as={Media} at="mobile">
              <div className="pdtxs pdbxs pdrxs pdlxs">
                {renderBody(confirmationMessageText)}
                {renderFooter(
                  callerSuccessAction,
                  () => {
                    closeModal(dispatch);
                  },
                  confirmationMessageText
                )}
              </div>
            </Container>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationCallMessage;
